module.exports = __webpack_public_path__ + "static/media/coding-lesson-plans.3f9aedac.webp";